Object.defineProperty(exports, "__esModule", {
  value: true
});

var FieldContext = function () {
  function FieldContext(fieldOptions) {
    this.fieldOptions = fieldOptions;
  }

  return FieldContext;
}();

exports.FieldContext = FieldContext;